import $ from 'jquery';

const closeModal = (modal) => {
    modal.removeClass('is-open').prop('aria-hidden', true);
    modal.find('.modal-close').prop('disabled', true);
    modal.find('input').prop('disabled', true);
    modal.find('#buttonMarketingSubmitNewsletterModal').prop('disabled', true);
}

const openModal = (modal) => {
    modal.addClass('is-open').prop('aria-hidden', false).trigger('focus');
    modal.find('.modal-close').prop('disabled', false);
    modal.find('input').prop('disabled', false);
    modal.find('#buttonMarketingSubmitNewsletterModal').prop('disabled', false);
}

const init = (modal) => {
    openModal(modal)
    modal.find('.modal-close').on('click', ()=>{
        closeModal(modal);
    })
}

const modal = $('.js-site-modal')
if (modal.length) {
    init(modal);
}
